import type { Locale, PublicInvitation } from "../shared/types";
import { text } from "./ui";

export function RsvpAnswerSummary({ invitation, locale, saved, onChange }: {
  invitation: PublicInvitation;
  locale: Locale;
  saved: boolean;
  onChange: () => void;
}) {
  if (invitation.status === "pending") return null;
  const attending = invitation.status === "confirmed";
  return (
    <div className={`rsvp-answer-summary ${attending ? "is-confirmed" : "is-declined"}`}>
      <div role={saved ? "status" : undefined}>
        <h3>{attending
          ? text(locale, "Katılacağınızı onayladınız.", "You’ve confirmed you’re coming.")
          : text(locale, "Katılamayacağınızı bildirdiniz.", "You’ve let us know you can’t attend.")}</h3>
        <p>{attending
          ? text(locale, "Sizinle buluşmayı sabırsızlıkla bekliyoruz.", "We look forward to seeing you.")
          : text(locale, "Haber verdiğiniz için teşekkür ederiz. Başka bir etkinlikte görüşmek dileğiyle.", "Thank you for letting us know. We hope to see you at another event.")}</p>
        {attending && <p className="rsvp-answer-summary__guests">{invitation.additionalGuests === 0
          ? text(locale, "Yalnız geliyorsunuz.", "You’re attending on your own.")
          : text(locale, `Sizinle birlikte toplam ${invitation.totalAttendees} kişi.`, `${invitation.totalAttendees} people attending, including you.`)}</p>}
        {attending && invitation.guestNames?.length ? <p>{invitation.guestNames.join(", ")}</p> : null}
        {attending && invitation.additionalGuests > (invitation.guestNames?.length || 0) && <p>{text(locale, "Lütfen yanıtınızı düzenleyerek ek misafirlerinizin adlarını tamamlayın.", "Please change your answer to add the names of your additional guests.")}</p>}
      </div>
      {invitation.editable && <button className="outline-button" type="button" onClick={onChange}>{text(locale, "Yanıtımı değiştir", "Change my answer")}</button>}
    </div>
  );
}
